import React from "react";
import { Button, Title, Description } from "../general/index";
import IconLabel from "./IconLabel";
import ProductBg from "../general/ProductBg";
import { useMedia } from "../../hooks/media";

const Feature = ({ title, label, color, description, icon, image, index }) => {
  const { screenSize } = useMedia();

  const largeScreen = screenSize >= 1024;

  return (
    <div className="feature-container flex">
      <div className="feature__image-container flex justify-center items-center relative">
        <img
          className="mb-8 shadow-md rounded"
          src={image.src}
          alt={image.alt}
        />
        {largeScreen && <ProductBg color={color} height="100%" width="100%" />}
      </div>
      <div className="feature__details relative">
        <IconLabel icon={icon} color={color} label={label} />
        <Title margin="2" fontSize="2xl">
          {title}
        </Title>
        <Description className="mb-6">{description}</Description>
        <Button
          as="a"
          href="https://chrome.google.com/webstore/detail/fructify/gpppkkkidmlbdenkajgcpfkjocmdbock"
          target="_blank"
        >
          Add to Chrome
        </Button>
        <h1 className="feature__index absolute">{index}</h1>
      </div>
    </div>
  );
};

export default Feature;
